module.exports = ".panel {\n  border: 1px solid #d1d6e6; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system-setting-component/edit-setting/edit-setting.component.scss
// module id = ./src/app/system-setting-component/edit-setting/edit-setting.component.scss
// module chunks = main